module.exports = __webpack_public_path__ + "element_petit_point_citation.svg?167540beeebbdc06f678aae240d85e78";


//////////////////
// WEBPACK FOOTER
// ./src/img/societe/element_petit_point_citation.svg
// module id = 261
// module chunks = 0